/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/localStorage/getEmailInLocalStorage';
import type { EmailAddress } from 'src/types/Id';

export function setEmailInLocalStorage(value: EmailAddress | void): void {
    if (value === undefined) {
        window.localStorage.removeItem(KEY_NAME);
        return;
    }
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value));
}
